import ReviewFooter from './ReviewFooter';

export default ReviewFooter;
